<template>
  <div id="tradingRecord">
    <div class="iconArea">
      <md-icon :name="'calendar'" @click="isDatePickerShow=true"/>
    </div>
    <div class="perMonth" v-for="(item,value) in filterList" :key="value">
      <div class="GridD99BAF1B" >
        <span  :text="'2020-10'" class="textCCB6F0EB">{{item.tranDate}}</span>
      </div>
      <div class="Grid82DD2F79" v-for="(item2,value2) in item.tranList" :key="value2">
        <div class="Grid1D5FDDBE">
          <span  :text="'賬戶支出'" class="textC877A976">
            {{$t('label.label175')}}{{getEventType(item2.eventType)}}
          </span>
          <span :text="'存款-月月高存款購買 2020-10-03 095034'" class="text75EAE427">
            {{getEventType(item2.eventType)}}-{{getProdType(item2.prodType)}} {{item2.tranTime|tranTime}}
          </span>
        </div>
        <div class="GridCB4F7190">
          <p :text="'-2000.00'" class="text2370C037">
            <span v-if="item2.crDrMaintInd === 'D'" style="color: #ff3e3e">+{{$commafy(item2.tranAmt)}}</span>
            <span v-else-if="item2.crDrMaintInd === 'C'" style="color: #1E1E1E">-{{$commafy(item2.tranAmt)}}</span>
          </p>
        </div>
      </div>
    </div>
    <div v-if="filterList.length !== 0" class="haveData">
      <span>
        {{$t('label.label201')}}
      </span>
    </div>
    <div v-if="isShow&&filterList.length === 0" class="noData">
      <span>
        {{$t('label.label174')}}
      </span>
    </div>
    <div class="popDown">
      <md-popup
        v-model="isPopupShow"
        :hasMask="true"
        :mask-closable="true"
        position="bottom"
      >
      <div class="popAreas">
        <p class="titleArea">
          <span class="titleCenter">{{$t('label.label82')}}</span>
          <span class="titleRight" @click="resetAll">{{$t('label.label83')}}</span>
        </p>
        <div class="popContent">
          <p class="smallTittle">{{$t('label.label84')}}</p>
          <div class="buttons" >
            <div class="perButton">
              <md-button type="primary" :class="{selected:!checkBox[0]}" @click="changeItem(0, checkBox)">{{$t('label.label85')}}</md-button>
              <md-button type="primary" v-for="item in checkBoxItem" :key="item.value" :class="{selected:!checkBox[item.value]}" @click="changeItem(item.value, checkBox)">
                {{item.text}}</md-button>
            </div>
          </div>
        </div>
        <div class="popContent">
          <p class="smallTittle">{{$t('label.label91')}}</p>
          <div class="buttons" >
            <div class="perButton">
              <md-button type="primary" :class="{selected:!checkBox2[0]}" @click="changeItem(0, checkBox2)">{{$t('label.label93')}}</md-button>
              <md-button type="primary" v-for="item in checkBoxItem2" :key="item.value" :class="{selected:!checkBox2[item.value]}" @click="changeItem(item.value, checkBox2)">
                {{item.text}}</md-button>
            </div>
          </div>
        </div>
      </div>
      </md-popup>
    </div>
    <div >
      <md-date-picker
        :ref="'datePicker'"
        v-model="isDatePickerShow"
        :type="'custom'"
        :title="$t('label.label176')"
        large-radius
        :ok-text="$t('btn.btn1')"
        :max-date="currentDate"
        :cancel-text="$t('btn.btn2')"
        :min-date="new Date('2021-01')"
        :default-date="currentDate"
        :custom-types="['yyyy', 'MM']"
        @confirm="onDatePickerConfirm"
      ></md-date-picker>
    </div>
  </div>
</template>
<script>
import { Icon, DatePicker } from '@gidc/mobile'
import { Popup, Button } from 'mand-mobile'
import { ACCTTRANDETAIL, CUSINFO } from '../../api/smartdeposit'
import { mapGetters } from 'vuex'
import dataCenterBus from '../../assets/dataCenterBus'
export default {
  name: 'tradingRecord',
  components: {
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [DatePicker.name]: DatePicker
  },
  computed: {
    ...mapGetters([
      'RnInfo'
    ]),
    filterList () {
      let list = JSON.parse(JSON.stringify(this.getData))
      const num = this.getData.length
      if (num) {
        if (!this.checkBox[0]) {
          const newCheck = []
          const newCheckBox = []
          for (let i = 1; i < 6; i++) {
            if (this.checkBox[i]) {
              newCheck.push(i)
            }
          }
          for (let i = 0; i < newCheck.length; i++) {
            newCheckBox.push(...this.checkBoxItem[newCheck[i] - 1].prodType.split('||'))
          }
          for (let i = 0; i < list.length; i++) {
            const ant = []
            for (let j = 0; j < list[i].tranList.length; j++) {
              if (newCheckBox.indexOf(list[i].tranList[j].prodType) > -1) {
                ant.push(list[i].tranList[j])
              }
            }
            list[i].tranList = ant
            if (list[i].tranList.length === 0) {
              list.splice(i, 1)
              i--
            }
          }
        }
        if (!this.checkBox2[0]) {
          const newCheck = []
          const newCheckBox = []
          for (let i = 1; i < 6; i++) {
            if (this.checkBox2[i]) {
              newCheck.push(i)
            }
          }
          for (let i = 0; i < newCheck.length; i++) {
            newCheckBox.push(this.checkBoxItem2[newCheck[i] - 1].eventType)
          }
          for (let i = 0; i < list.length; i++) {
            const ant = []
            for (let j = 0; j < list[i].tranList.length; j++) {
              if (newCheckBox.indexOf(list[i].tranList[j].eventType) > -1) {
                ant.push(list[i].tranList[j])
              }
            }
            list[i].tranList = ant
            if (list[i].tranList.length === 0) {
              list.splice(i, 1)
              i--
            }
          }
        }
        if (this.datePickerValue) {
          for (let i = 0; i < num; i++) {
            if (this.getData[i].tranDate === this.datePickerValue) {
              list = list.splice(i, 1)
              break
            }
            if ((i === (num - 1)) && this.getData[i].tranDate !== this.datePickerValue) {
              list = list.splice(i, 0)
            }
          }
        } else {
          const pre = new Date(JSON.parse(JSON.stringify(this.currentDate)))
          pre.setFullYear(pre.getFullYear() - 1)
          pre.setMonth(pre.getMonth() + 1)
          let dateStr = pre.getFullYear() + '-' + (pre.getMonth() + 1)
          if (dateStr.length === 6) {
            dateStr = dateStr.replace('-', '-0')
          }
          for (let i = 0; i < num; i++) {
            if (this.getData[i].tranDate < dateStr) {
              list = list.slice(0, i)
              break
            }
          }
        }
      }
      return list
    }
  },
  data () {
    return {
      isPopupShow: false,
      isDatePickerShow: false,
      checkBox: [true, false, false, false, false, false],
      checkBox2: [true, false, false, false, false, false],
      datePickerValue: '',
      checkBoxItem: [
        {
          text: this.$t('label.label86'),
          prodType: 'FP01060005',
          value: 1
        },
        {
          text: this.$t('label.label87'),
          prodType: 'FP01060006',
          value: 2
        },
        {
          text: this.$t('label.label88'),
          prodType: 'FP01060004',
          value: 3
        },
        {
          text: this.$t('label.label89'),
          prodType: 'FP01060001',
          value: 4
        },
        {
          text: this.$t('label.label90'),
          prodType: 'FP01060002||FP01060014',
          value: 5
        }
      ],
      checkBoxItem2: [
        {
          text: this.$t('label.label92'),
          eventType: 'FP1001',
          value: 1
        },
        {
          text: this.$t('label.label94'),
          eventType: 'FP1003',
          value: 2
        },
        {
          text: this.$t('label.label95'),
          eventType: 'FP1005',
          value: 3
        },
        {
          text: this.$t('label.label96'),
          eventType: 'FP1009',
          value: 4
        },
        {
          text: this.$t('label.label97'),
          eventType: 'FP1010',
          value: 5
        }
      ],
      getData: [],
      currentDate: new Date(),
      isShow: false
    }
  },
  filters: {
    tranTime: function (item) {
      const yyyy = item.substr(0, 4)
      const MM = item.substr(4, 2)
      const dd = item.substr(6, 2)
      const hh = item.substr(9, 2)
      const mm = item.substr(12, 2)
      const ss = item.substr(15, 2)
      return yyyy + '-' + MM + '-' + dd + ' ' + hh + ':' + mm + ':' + ss
    }
  },
  methods: {
    changeItem (item, arr) {
      const t = arr[item]
      arr.splice(item, 1, !t)
      if (item === 0) {
        arr[0] = true
        for (let i = 1; i < arr.length; i++) {
          arr[i] = false
        }
      } else {
        if (!t) {
          if (arr[0]) {
            arr[0] = false
          }
          let status = true
          for (let i = 1; i < arr.length; i++) {
            status = status && arr[i]
          }
          if (status) {
            arr[0] = true
            for (let i = 1; i < arr.length; i++) {
              arr[i] = false
            }
          }
        } else {
          let status = false
          for (let i = 1; i < arr.length; i++) {
            status = status || arr[i]
          }
          console.log(status)
          if (!status) {
            arr[0] = true
          }
        }
      }
    },
    resetAll () {
      this.checkBox = [true, false, false, false, false, false]
      this.checkBox2 = [true, false, false, false, false, false]
    },
    getAcctList (obj) {
      const params = {
        documentId: obj.idNo,
        documentType: obj.idType
      }
      this.$remote.post(ACCTTRANDETAIL + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          this.isShow = true
          console.log('this is AcctList', res)
          this.getData = res.list
        })
    },
    getCusInfo () {
      this.$remote.post(CUSINFO + '?_locale=' + this.$exchangeLang(this.RnInfo.language), {}, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          console.log('this is CusInfo', res)
          this.getAcctList(res)
        })
    },
    setFilters () {
      dataCenterBus.$on('myFun', (message) => {
        this.isPopupShow = message
      })
    },
    onDatePickerConfirm () {
      this.datePickerValue = this.$refs.datePicker.getFormatDate('yyyy-MM')
      console.log('this is AcctList', this.datePickerValue)
    },
    getProdType: function (item) {
      let result
      if (item) {
        if (item === 'FP01060001') {
          result = this.$t('label.label89')
        } else if (item === 'FP01060002') {
          result = this.$t('label.label90')
        } else if (item === 'FP01060014') {
          result = this.$t('label.label90')
        } else if (item === 'FP01060004') {
          result = this.$t('label.label88')
        } else if (item === 'FP01060005') {
          result = this.$t('label.label86')
        } else if (item === 'FP01060006') {
          result = this.$t('label.label87')
        }
      }
      return result
    },
    getEventType: function (item) {
      let result
      if (item) {
        if (item === 'FP1001') {
          result = this.$t('label.label92')
        } else if (item === 'FP1003') {
          result = this.$t('label.label94')
        } else if (item === 'FP1005') {
          result = this.$t('label.label95')
        } else if (item === 'FP1009') {
          result = this.$t('label.label96')
        } else if (item === 'FP1010') {
          result = this.$t('label.label97')
        }
      }
      return result
    }
  },
  created () {
    this.getCusInfo()
  },
  mounted () {
    this.setFilters()
  }
}
</script>
<style lang="stylus">
  #tradingRecord{
    .popDown{
      .popAreas{
        background #F5F5F5
        padding .36rem .3rem .2rem .25rem
        width 100vw
        box-sizing border-box
        overflow hidden
        font-size .3rem
        .titleArea{
          height .5rem
          display flex
          justify-content center
          position relative
          .titleCenter{
            line-height .48rem
            height .5rem
            font-size .36rem
            font-weight 400
            color #1E1E1E
          }
          .titleRight{
            position absolute
            right 0
            bottom 0
            line-height .4rem
            height .4rem
            font-size .28rem
            font-weight 400
            color #3A56D8
          }
        }
        .popContent{
          padding-bottom .52rem
          width calc(100vw - .6rem)
          .smallTittle{
            height .4rem
            font-size .28rem
            font-weight 500
            color #1E1E1E
            line-height .4rem
            padding-bottom .23rem
          }
          .buttons{
            .perButton{
              display grid
              grid-template-columns repeat(2,1fr)
              grid-template-rows  repeat(auto,1fr)
              grid-row-gap: .28rem;
              grid-column-gap: .23rem;
              justify-content space-between
              padding 0 .1rem .1rem 0
              .md-button{
                height .81rem
                border none
                border-radius .09rem
                outline none
                .md-button-content{
                  color #FFFFFF
                  font-size .24rem
                  font-weight 400
                  line-height .4rem
                  height .4rem
                  white-space:nowrap;
                }
              }
              .primary{
                background #3083F5
              }
              .primary::after{
                content none
              }
              .md-button.selected{
                .md-button-content{
                  color #1E1E1E
                  white-space:nowrap;
                }
              }
              .primary.selected{
                background: #FFFFFF;
              }
            }
          }
        }
      }
    }
    .md-date-picker{
      .md-popup-title-bar .title-bar-left, .md-popup-title-bar .title-bar-right{
        min-width 20%
        width auto
      }
    }
  }
</style>
<style lang="stylus" scoped>
  #tradingRecord{
    position relative
    height calc(100vh - .9rem)
    overflow auto
    .iconArea{
      position absolute
      left 92%
      top .1rem
      transform translate(-50%,-50%)
    }
    .haveData{
      span{
        text-align center
        display block
        height .36rem
        font-size .28rem
        font-weight 400
        color #999999
        line-height .36rem
      }
    }
    .noData{
      position absolute
      left 50%
      top 40%
      transform translate(-50%,-50%)
      span{
        height .48rem
        font-size .36rem
        font-weight 400
        color #999999
        line-height .36rem
      }
    }
    .perMonth{
      .GridD99BAF1B{
        display flex
        justify-content space-between
        padding .16rem .3rem .1rem
        height .4rem
        line-height .4rem
        .textCCB6F0EB{
          display inline-block
          font-size .2rem
          font-weight 400
          color #666666
        }
      }
      .Grid82DD2F79{
        padding 0 .3rem
        display flex
        height 1.48rem
        position relative
        .Grid1D5FDDBE{
          width 67%
          display flex
          flex-direction column
          justify-content center
          .textC877A976{
            padding-bottom .07rem
            font-size .28rem
            height .4rem
            font-weight 400
            color #1E1E1E
            line-height .4rem
          }
          .text75EAE427{
            font-size .2rem
            font-weight 400
            color #666666
            line-height .4rem
            word-wrap break-spaces
          }
        }
        .GridCB4F7190{
          width 33%
          display: flex;
          justify-content flex-end
          align-items center
          .text2370C037{
            height .45rem
            font-size .32rem
            font-weight 600
            color #1E1E1E
            line-height .45rem
          }
        }
      }
      .Grid82DD2F79:after{
        content ''
        width 92%
        height .02rem
        background: #ECECEC;
        position absolute
        bottom 0
      }
      .Grid82DD2F79:last-child:after{
        content none
      }
    }
    .perMonth + .perMonth{
      border-top .4rem solid #F8F8F8
    }
  }
</style>
